import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { isBeforeToday, isValidDate } from '../../../../../util/date';

export const getDueStatus = (completed: boolean, dueDate?: Dayjs) => {
    if (completed)
        return { color: 'success.main', label: 'Completed' };

    if (!dueDate || !isValidDate(dueDate))
        return { color: 'warning.main', label: 'Pending' };

    const now = dayjs();
    const due = dayjs(dueDate);

    if (isBeforeToday(dueDate.toString())) {
        return { color: 'error.main', label: 'Overdue' };
    }
    if (due.isSame(now, 'day')) {
        return { color: 'error.main', label: 'Due Today' };
    }
    if (due.isBefore(now.add(2, 'day'))) {
        return { color: 'warning.main', label: 'Due Soon' };
    }
    return { color: 'info.main', label: 'Upcoming' };
}; 